import { SVGProps } from 'react'

export function GBFlag(props: SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 60 30" {...props}>
			<clipPath id="gb-clip"><rect x="0" y="0" width="60" height="30" rx="4" /></clipPath>
			<g clipPath="url(#gb-clip)">
				<rect width="60" height="30" fill="#012169" />
				<path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
				<path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
				<path d="M30,0 V30 M0,15 H60" stroke="#fff" strokeWidth="10" />
				<path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
			</g>
		</svg>
	)
}

export function DEFlag(props: SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 5 3" {...props}>
			<clipPath id="de-clip"><rect x="0" y="0" width="5" height="3" rx="0.3" /></clipPath>
			<g clipPath="url(#de-clip)">
				<rect width="5" height="1" y="0" fill="#000" />
				<rect width="5" height="1" y="1" fill="#D00" />
				<rect width="5" height="1" y="2" fill="#FFCE00" />
			</g>
		</svg>
	)
}

export function EUFlag(props: SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 810 540" {...props}>
			<rect fill="#003399" width="810" height="540" />
			<g fill="#FFCC00" transform="translate(405,270)">
				{Array.from({ length: 12 }).map((_, i) => {
					const angle = (i * 30 - 90) * (Math.PI / 180)
					const x = Math.cos(angle) * 160
					const y = Math.sin(angle) * 160
					return <polygon key={i} points="0,-16 4.5,-5.5 16,-5.5 7,2 10.5,13.5 0,6.5 -10.5,13.5 -7,2 -16,-5.5 -4.5,-5.5" transform={`translate(${x},${y})`} />
				})}
			</g>
		</svg>
	)
}
